import React from "react";

export const SelectCardContainer = ({ children, isDetailsActive }) => {
  if (isDetailsActive) return null;

  return <div className="selectCard">{children}</div>;
};
